import { useState } from "react";
import { routes } from "../../../constants";
import { baseRouteMaker } from "../../../constants/routeConsts";
import { t } from "i18next";

export const useStaffAppointmentsMenuUtils = () => {
  const [menuGroup, setMenuGroup] = useState(() => {
    const tempMenuGroup = [];

    /* menuItemCalendar */
    const menuItemCalendar = {
      id: "calendar",
      title: t("tabs.calender"),
      url: baseRouteMaker(routes.STAFF_CALENDAR),
    };
    tempMenuGroup.push(menuItemCalendar);
    /* menuItemCalendar */

    /* menuItemAppointments */
    const menuItemAppointments = {
      id: "appointments",
      title: "Appointments Info",
      url: baseRouteMaker(routes.STAFF_APPOINTMENT_INFO),
    };
    tempMenuGroup.push(menuItemAppointments);
    /* menuItemAppointments */

    return tempMenuGroup;
  });

  return menuGroup;
};
